import React, { PureComponent } from 'react';
import { Icon, Row, Col, Input } from 'antd';
import { language } from '../../../language';
import { cloneDeep, get } from 'lodash';
import { LinkType } from '../../tools';

//
export class SearchBarItem extends PureComponent<any> {
    state = {
        uploadLoading: false,
    };
    change = (item) => {
        const { items, onChange, index } = this.props;
        let newItems = cloneDeep(items);
        newItems.splice(index, 1, item);
        onChange(newItems);
    };

    onContentChange = (event) => {
        const { item } = this.props;
        let newItem = cloneDeep(item);
        let newValue = { ...newItem, content: event.target.value };
        this.change(newValue);
    };

    removeItem = () => {
        const { items, onChange, index } = this.props;
        let newValue = cloneDeep(items);
        newValue.splice(index, 1);
        onChange(newValue);
    };

    render() {
        const { item, linkTypes, linkTypeMode, selector } = this.props;
        return (
            <Row className="entry-item">
                <Icon type="close" className="item-remove" title="移除" onClick={this.removeItem} />
                <Col className="entry-item-content" span={19}>
                    <div className="link-item-field">
                        <label className="field-name">
                            {language.getText('components.SearchBar.keywords')}：{' '}
                        </label>
                        <Input
                            className="field-control"
                            value={get(item, 'content')}
                            onChange={this.onContentChange}
                        />
                    </div>
                    <LinkType
                        linkTypes={linkTypes}
                        linkTypeMode={linkTypeMode}
                        value={item}
                        selector={selector}
                        onChange={(item) => {
                            this.change(item);
                        }}
                    />
                </Col>
            </Row>
        );
    }
}
